import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { accessLevelTop } from '@constants/navbar';
import { ROUTES_ADMIN } from '@constants/routes';
import { User } from '@models/entities/user';
import { UserManagerService } from '@providers/user-manager/user-manager.service';


@Injectable({
  providedIn: 'root'
})
export class RedirectService {

  constructor(
    private route: Router,
    private userService: UserManagerService
  ) { }

  redirect(to: any, data?): void { this.route.navigate([to], data); }

  redirectToInit(): void {
    const user: User = this.userService.currentUser;
    if (user?.privileges.length > 0) {
      let optionModule;
      let filter;
      for (const access in accessLevelTop) {
        filter = accessLevelTop[access];
        optionModule = user.privileges.find(privilege => privilege.name === filter.privilegeName);
        if (optionModule) {
          break;
        }
      }
      if (optionModule?.name && filter?.route) {
        this.redirect(filter.route);
        return;
      }
    }
    this.route.navigate([ROUTES_ADMIN.NOT_FOUND_ROUTE]);
  }

  redirectToDriverInfo(redirect: string): void { this.redirect(ROUTES_ADMIN.DRIVERS_ROUTE+redirect); }

  getRouteUrl(): string { return (this.route) ? this.route.url : ''; }
  getRouter(): Router { return this.route; }
}
